import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "week-title" }
const _hoisted_2 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_SelectField = _resolveComponent("SelectField")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_adjustment = _resolveComponent("adjustment")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_reaction = _resolveComponent("reaction")!
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")!
  const _component_EvaluateTimeSheet = _resolveComponent("EvaluateTimeSheet")!
  const _component_TeammembersStatus = _resolveComponent("TeammembersStatus")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card_title, null, {
      default: _withCtx(() => [
        _cache[22] || (_cache[22] = _createTextVNode(" Weekly Timesheet Audit ")),
        _createVNode(_component_v_divider, {
          class: "mx-4",
          inset: "",
          vertical: ""
        }),
        _createVNode(_component_v_spacer)
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      loading: _ctx.loading,
      disabled: _ctx.loading,
      class: "audit-body"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "align-center flex-nowrap"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  icon: "",
                  class: "ma-2",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onPrevWeekClicked()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                        _createTextVNode("mdi-chevron-left")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.weekTitle()), 1),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  icon: "",
                  class: "ma-2",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onNextWeekClicked()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                        _createTextVNode("mdi-chevron-right")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                (_ctx.isAdmin)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      md: "3",
                      sm: "4",
                      xs: "12",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SelectField, {
                          items: _ctx.linemanagers,
                          "item-title": "FirstName",
                          "item-value": "id",
                          modelValue: _ctx.selectedLineManager,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedLineManager) = $event)),
                          label: "Line Manager",
                          outlined: "",
                          dense: ""
                        }, null, 8, ["items", "modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_col, {
                  md: "3",
                  sm: "4",
                  xs: "12",
                  cols: "12"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectField, {
                      disabled: !_ctx.filteredCommitments.length,
                      "menu-props": { bottom: true, offsetY: true },
                      items: _ctx.TeamMembers,
                      "item-title": "TmFullName",
                      "item-value": "id",
                      modelValue: _ctx.selectedTeamMemberId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedTeamMemberId) = $event)),
                      label: "Team Member",
                      placeholder: "Team Member",
                      outlined: ""
                    }, null, 8, ["disabled", "items", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["loading", "disabled"]),
    _createVNode(_component_v_card, {
      class: "mt-3",
      loading: _ctx.loading || _ctx.tableLoading,
      disabled: _ctx.loading || _ctx.tableLoading
    }, {
      default: _withCtx(() => [
        (_ctx.commitmentsWithRelations.commitments && _ctx.commitmentsWithRelations.commitments.length)
          ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_data_table, {
                  headers: _ctx.commitmentHeaders,
                  items: _ctx.filteredCommitments,
                  "single-expand": true,
                  "item-key": "id",
                  class: "elevation-1 custom-table-row"
                }, {
                  "item.actions": _withCtx(({ item }) => [
                    (!_ctx.isAdmin)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          class: "btn-white",
                          onClick: ($event: any) => (_ctx.ApproveOrRevokeWeeklyTimesheetAudit(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.CheckWeeklyTimesheetAuditNotRevoked(item.id) ? "Revoke Approval" : "Approve"), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          disabled: true,
                          class: "btn-white"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.CheckWeeklyTimesheetAuditNotRevoked(item.id) ? "Approved" : "Not Approved"), 1)
                          ]),
                          _: 2
                        }, 1024))
                  ]),
                  "item.TimeSheetReport": _withCtx(({ item }) => [
                    _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                      onClick: ($event: any) => (_ctx.showTeammembersStatusMenu(item.id)),
                      variant: "text"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { icon: "mdi-chart-box" })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_tooltip, 'Time Sheets Overal Status']
                    ])
                  ]),
                  "item.SumTimesheet": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(_ctx.SumTimeSheet(item)), 1)
                  ]),
                  "item.SumLeave": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(_ctx.SumLeave(item)), 1)
                  ]),
                  "item.SumAdjustment": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(_ctx.SumAdjustment(item)), 1)
                  ]),
                  "item.SubTotal": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(_ctx.SubTotal(item)), 1)
                  ]),
                  "item.TeamMember": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(item.TeamMember && item.TeamMember.TmFullName), 1)
                  ]),
                  "expanded-row": _withCtx(({ columns, item }) => [
                    _createElementVNode("td", {
                      colspan: columns.length,
                      class: "data-table-expanded-content custom-timesheet-row pa-2"
                    }, [
                      _createVNode(_component_v_row, { class: "ma-0" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { xs: "2" }, {
                            default: _withCtx(() => _cache[25] || (_cache[25] = [
                              _createTextVNode(" Date ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { xs: "2" }, {
                            default: _withCtx(() => _cache[26] || (_cache[26] = [
                              _createTextVNode(" IssueNo ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { xs: "2" }, {
                            default: _withCtx(() => _cache[27] || (_cache[27] = [
                              _createTextVNode(" Project ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { xs: "2" }, {
                            default: _withCtx(() => _cache[28] || (_cache[28] = [
                              _createTextVNode(" Epic ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { xs: "2" }, {
                            default: _withCtx(() => _cache[29] || (_cache[29] = [
                              _createTextVNode(" Activity ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { xs: "2" }, {
                            default: _withCtx(() => _cache[30] || (_cache[30] = [
                              _createTextVNode(" Technology ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { xs: "2" }, {
                            default: _withCtx(() => _cache[31] || (_cache[31] = [
                              _createTextVNode(" Effort ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { xs: "2" }, {
                            default: _withCtx(() => _cache[32] || (_cache[32] = [
                              _createTextVNode(" Adjustment ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { xs: "2" }, {
                            default: _withCtx(() => _cache[33] || (_cache[33] = [
                              _createTextVNode(" Time Sheet Status ")
                            ])),
                            _: 1
                          }),
                          (!_ctx.CheckWeeklyTimesheetAuditNotRevoked(item.id))
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                xs: "2",
                                class: "text-center"
                              }, {
                                default: _withCtx(() => _cache[34] || (_cache[34] = [
                                  _createTextVNode(" Action ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterTimeSheet(item.id), (timesheet) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: timesheet.id,
                          class: "timesheet-row",
                          style: _normalizeStyle({ background: timesheet.backgroundColor })
                        }, [
                          _createVNode(_component_v_row, { class: "ma-0" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { xs: "2" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.getDateStr(timesheet.Date)), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, { xs: "2" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(timesheet.IssueNo), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, { xs: "2" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(timesheet.Project && timesheet.Project.Name), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, { xs: "2" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(timesheet.Epic), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, { xs: "2" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(timesheet.Activity), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, { xs: "2" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(timesheet.Technology), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, { xs: "2" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(timesheet.Effort), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, { xs: "2" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(timesheet.Adjustment), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, { xs: "2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_chip, {
                                    color: _ctx.getLabelColor(timesheet.PredictedLabel)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getTimeSheetLabel(timesheet.PredictedLabel)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"])
                                ]),
                                _: 2
                              }, 1024),
                              (!_ctx.CheckWeeklyTimesheetAuditNotRevoked(item.id))
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    xs: "2",
                                    class: "text-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_menu, {
                                        bottom: "",
                                        left: ""
                                      }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_icon, _mergeProps({ ref_for: true }, props), {
                                            default: _withCtx(() => _cache[35] || (_cache[35] = [
                                              _createTextVNode("mdi-dots-vertical")
                                            ])),
                                            _: 2
                                          }, 1040)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item, {
                                                onClick: ($event: any) => (_ctx.OnAdjustmentClick(timesheet)),
                                                disabled: timesheet.IsLeave,
                                                "prepend-icon": "mdi-tune",
                                                title: "Adjustment"
                                              }, null, 8, ["onClick", "disabled"]),
                                              (!_ctx.isAdmin)
                                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                    key: 0,
                                                    onClick: ($event: any) => (_ctx.OnReactClick(timesheet)),
                                                    disabled: timesheet.IsLeave,
                                                    "prepend-icon": "mdi-emoticon",
                                                    title: "React"
                                                  }, null, 8, ["onClick", "disabled"]))
                                                : _createCommentVNode("", true),
                                              _createVNode(_component_v_list_item, {
                                                "prepend-icon": "mdi-comment-plus",
                                                title: "Evaluate",
                                                onClick: ($event: any) => {_ctx.timeSheetIdForEvaluation = timesheet.id; _ctx.openEvaluateTimeSheetDialog = true}
                                              }, null, 8, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_row, { class: "ma-0 mt-2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                xs: "12",
                                class: "description"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Description: " + _toDisplayString(timesheet.Description), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ], 4))
                      }), 128))
                    ], 8, _hoisted_2)
                  ]),
                  _: 1
                }, 8, ["headers", "items"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["loading", "disabled"]),
    (_ctx.showAdjustmentDialog)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 0,
          persistent: "",
          modelValue: _ctx.showAdjustmentDialog,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showAdjustmentDialog) = $event)),
          onKeydown: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.showAdjustmentDialog = false), ["esc"])),
          "max-width": "440px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_adjustment, {
              onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showAdjustmentDialog = false)),
              onSaved: _ctx.updateAdjustment,
              onErrorRaised: _ctx.errorRaised,
              isAdmin: _ctx.isAdmin,
              id: _ctx.selectedTimeSheet.id,
              ad: Number(_ctx.selectedTimeSheet.Adjustment)
            }, null, 8, ["onSaved", "onErrorRaised", "isAdmin", "id", "ad"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.showReactionDialog)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 1,
          persistent: "",
          modelValue: _ctx.showReactionDialog,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showReactionDialog) = $event)),
          onKeydown: _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.showReactionDialog = false), ["esc"])),
          "max-width": "440px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_reaction, {
              onCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showReactionDialog = false)),
              onSaved: _ctx.updateReaction,
              onErrorRaised: _ctx.errorRaised,
              onSuccessRaised: _ctx.successRaised,
              timesheetId: _ctx.selectedTimeSheet.id
            }, null, 8, ["onSaved", "onErrorRaised", "onSuccessRaised", "timesheetId"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.showRevokeDialog)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 2,
          modelValue: _ctx.showRevokeDialog,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showRevokeDialog) = $event)),
          "max-width": "500",
          onKeydown: _cache[13] || (_cache[13] = _withKeys(($event: any) => (_ctx.showRevokeDialog = false), ["esc"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_confirm_dialog, {
              message: { title: 'Process Confirmation', text: 'Are you sure you want to Revoke ?' },
              showDialog: _ctx.showRevokeDialog,
              onCancel: _cache[10] || (_cache[10] = ($event: any) => (_ctx.CancelRevokeDialog())),
              onConfirm: _cache[11] || (_cache[11] = ($event: any) => (_ctx.ConfirmRevokeDialog()))
            }, null, 8, ["showDialog"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.showApproveDialog)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 3,
          modelValue: _ctx.showApproveDialog,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.showApproveDialog) = $event)),
          "max-width": "500",
          onKeydown: _cache[17] || (_cache[17] = _withKeys(($event: any) => (_ctx.showApproveDialog = false), ["esc"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_confirm_dialog, {
              message: { title: 'Process Confirmation', text: 'Are you sure you want to Approve ?' },
              showDialog: _ctx.showApproveDialog,
              onCancel: _cache[14] || (_cache[14] = ($event: any) => (_ctx.CancelApproveDialog())),
              onConfirm: _cache[15] || (_cache[15] = ($event: any) => (_ctx.ConfirmApproveDialog()))
            }, null, 8, ["showDialog"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.openEvaluateTimeSheetDialog,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.openEvaluateTimeSheetDialog) = $event)),
      width: "auto"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_EvaluateTimeSheet, {
          onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.openEvaluateTimeSheetDialog = false)),
          timeSheetId: _ctx.timeSheetIdForEvaluation,
          onErrorRaised: _ctx.errorRaised,
          onSuccessRaised: _ctx.successRaised
        }, null, 8, ["timeSheetId", "onErrorRaised", "onSuccessRaised"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showTeammembersStatus,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.showTeammembersStatus) = $event)),
      "max-width": "700"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TeammembersStatus, {
          onClose: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showTeammembersStatus = false)),
          "labels-count": _ctx.labelsCount
        }, null, 8, ["labels-count"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}